/**
 * /!\ This file is auto-generated.
 *
 * This is the entry point of your standalone application.
 *
 * There are multiple tags used by the editor to inject code automatically:
 *     - `wle:auto-imports:start` and `wle:auto-imports:end`: The list of import statements
 *     - `wle:auto-register:start` and `wle:auto-register:end`: The list of component to register
 */

/* wle:auto-imports:start */
import {AudioListener} from '@wonderlandengine/components';
import {Cursor} from '@wonderlandengine/components';
import {CursorTarget} from '@wonderlandengine/components';
import {Trail as Trail1} from './components/trail.js';
import {AnimationController} from '@wonderlandengine/tweenjs';
import {GetDailyRewardParams} from './components/GetDailyRewardParams.js';
import {RewardAwarder} from './components/RewardAwarder.js';
import {UILocalize} from './components/UI-localize.js';
import {AdManager} from './components/ad-manager.js';
import {AdReward} from './components/ad-manager.js';
import {IslandSharkCircle} from './components/animations/IslandSharkCircle.js';
import {IslandSharkSwim} from './components/animations/IslandSharkSwim.js';
import {AudioDirector} from './components/audio-director.js';
import {Billboard} from './components/billboard.js';
import {BlobInjector} from './components/blob-injector.js';
import {BlobPrefabs} from './components/blob-prefabs.js';
import {BoardObject} from './components/board-object.js';
import {BombButtonTutorial} from './components/bomb-button-tutorial.js';
import {BooleanStore} from './components/boolean-store.js';
import {CalculateAspect} from './components/calculate-aspect.js';
import {ColumnAnimator} from './components/column-animator.js';
import {ColumnWarning} from './components/column-warning.js';
import {CreditsScene} from './components/credits-scene.js';
import {CurtainsController} from './components/curtains-controller.js';
import {DailyRewardManager} from './components/daily-rewards-manager.js';
import {DieAfterTime} from './components/die-after-time.js';
import {Environment} from './components/environment.js';
import {FruitPrefabs} from './components/fruit-prefabs.js';
import {FruitSmasherButton} from './components/fruit-smasher-button.js';
import {FXPrefabs} from './components/fx-prefabs.js';
import {GameFlowController} from './components/game-flow-controller.js';
import {GameMode} from './components/game-mode.js';
import {IncrementStatOnSpawn} from './components/increment-stat-on-spawn.js';
import {KeyboardController} from './components/keyboard-controller.js';
import {LaneHighlight} from './components/lane-highlight.js';
import {LeaderboardManager} from './components/leaderboard-manager.js';
import {LevelSelect} from './components/level-select.js';
import {LineSpawnerNormal} from './components/line-spawner-normal.js';
import {LineSpawnerPiece} from './components/line-spawner-normal.js';
import {MalAnimation} from './components/mal-animation.js';
import {MalFacialAnimationUi} from './components/mal-facial-animation-ui.js';
import {MissionManager} from './components/mission-manager.js';
import {ModeAwareSpawner} from './components/mode-aware-spawner.js';
import {MusicDirector} from './components/music-director.js';
import {PauseUnpause} from './components/pause-unpause.js';
import {PlayOneOffSFX} from './components/play-one-off-SFX.js';
import {PowerupManager} from './components/powerup-manager.js';
import {PurchaseManager} from './components/purchase-manager.js';
import {SkuAmount} from './components/purchase-manager.js';
import {PuzzleCamera} from './components/puzzle-camera.js';
import {Puzzle} from './components/puzzle.js';
import {RankManager} from './components/rank-manager.js';
import {RetargetAnimationOnStart} from './components/retarget-animation-on-start.js';
import {RewardPicker} from './components/reward-picker.js';
import {RewardScene} from './components/reward-scene.js';
import {EasyGameRules} from './components/rules/easy-game-rules.js';
import {QuickPlayGameRules} from './components/rules/quick-play-game-rules.js';
import {ScoreController} from './components/score-controller.js';
import {ScrollingUv} from './components/scrolling-uv.js';
import {SegmentedMusicPlayer} from './components/segmented-music-player.js';
import {TweenPositionAnimation} from './components/simple-animations/tween-position-animation.js';
import {TweenScaleAnimation} from './components/simple-animations/tween-scale-animation.js';
import {SpawnPieceButton} from './components/spawn-piece-button.js';
import {SpawnScoreAfterSeconds} from './components/spawn-score-after-seconds.js';
import {SpecialPower} from './components/special-power.js';
import {BombPower} from './components/special-powers/bomb-power.js';
import {BonusCountdownPower} from './components/special-powers/bonus-countdown-power.js';
import {CoinPower} from './components/special-powers/coin-power.js';
import {TntPower} from './components/special-powers/tnt-power.js';
import {StartStopAnimationOnActivate} from './components/start-stop-animation-on-activate.js';
import {Statistics} from './components/statistics.js';
import {StoreManager} from './components/store-manager.js';
import {Tags} from './components/tags.js';
import {TallyEndTotals} from './components/tally-end-totals.js';
import {TimeManager} from './components/time-manager.js';
import {TouchController} from './components/touch-controller.js';
import {TransitionController} from './components/transition-controller.js';
import {TutorialGameRules} from './components/tutorial-game-rules.js';
import {TutorialSpawner} from './components/tutorial-spawner.js';
import {TutorialTextScript} from './components/tutorial-text-script.js';
import {UnlockManager} from './components/unlock-manager.js';
import {WarningLine} from './components/warning-line.js';
import {UiTexturesManager} from './ui/components/ui-textures-manager.js';
import {CreditsList} from './ui/credits-list.tsx';
import {MainUI} from './ui/main-ui.tsx';
import {AchievementIcons} from './ui/panels/notification.tsx';
import {CurtainsComponent} from './ui/panels/rewards.tsx';
import {UnlockIcons} from './ui/panels/unlocked-something.tsx';
/* wle:auto-imports:end */
import { Localization } from './utils/Localization.js';

if (!WL_EDITOR) {
    // get the localization initialized
    console.log(Localization.instance.get('Welcome12'));
}


export default function (engine) {

    /* wle:auto-register:start */
engine.registerComponent(AudioListener);
engine.registerComponent(Cursor);
engine.registerComponent(CursorTarget);
engine.registerComponent(Trail1);
engine.registerComponent(AnimationController);
engine.registerComponent(GetDailyRewardParams);
engine.registerComponent(RewardAwarder);
engine.registerComponent(UILocalize);
engine.registerComponent(AdManager);
engine.registerComponent(AdReward);
engine.registerComponent(IslandSharkCircle);
engine.registerComponent(IslandSharkSwim);
engine.registerComponent(AudioDirector);
engine.registerComponent(Billboard);
engine.registerComponent(BlobInjector);
engine.registerComponent(BlobPrefabs);
engine.registerComponent(BoardObject);
engine.registerComponent(BombButtonTutorial);
engine.registerComponent(BooleanStore);
engine.registerComponent(CalculateAspect);
engine.registerComponent(ColumnAnimator);
engine.registerComponent(ColumnWarning);
engine.registerComponent(CreditsScene);
engine.registerComponent(CurtainsController);
engine.registerComponent(DailyRewardManager);
engine.registerComponent(DieAfterTime);
engine.registerComponent(Environment);
engine.registerComponent(FruitPrefabs);
engine.registerComponent(FruitSmasherButton);
engine.registerComponent(FXPrefabs);
engine.registerComponent(GameFlowController);
engine.registerComponent(GameMode);
engine.registerComponent(IncrementStatOnSpawn);
engine.registerComponent(KeyboardController);
engine.registerComponent(LaneHighlight);
engine.registerComponent(LeaderboardManager);
engine.registerComponent(LevelSelect);
engine.registerComponent(LineSpawnerNormal);
engine.registerComponent(LineSpawnerPiece);
engine.registerComponent(MalAnimation);
engine.registerComponent(MalFacialAnimationUi);
engine.registerComponent(MissionManager);
engine.registerComponent(ModeAwareSpawner);
engine.registerComponent(MusicDirector);
engine.registerComponent(PauseUnpause);
engine.registerComponent(PlayOneOffSFX);
engine.registerComponent(PowerupManager);
engine.registerComponent(PurchaseManager);
engine.registerComponent(SkuAmount);
engine.registerComponent(PuzzleCamera);
engine.registerComponent(Puzzle);
engine.registerComponent(RankManager);
engine.registerComponent(RetargetAnimationOnStart);
engine.registerComponent(RewardPicker);
engine.registerComponent(RewardScene);
engine.registerComponent(EasyGameRules);
engine.registerComponent(QuickPlayGameRules);
engine.registerComponent(ScoreController);
engine.registerComponent(ScrollingUv);
engine.registerComponent(SegmentedMusicPlayer);
engine.registerComponent(TweenPositionAnimation);
engine.registerComponent(TweenScaleAnimation);
engine.registerComponent(SpawnPieceButton);
engine.registerComponent(SpawnScoreAfterSeconds);
engine.registerComponent(SpecialPower);
engine.registerComponent(BombPower);
engine.registerComponent(BonusCountdownPower);
engine.registerComponent(CoinPower);
engine.registerComponent(TntPower);
engine.registerComponent(StartStopAnimationOnActivate);
engine.registerComponent(Statistics);
engine.registerComponent(StoreManager);
engine.registerComponent(Tags);
engine.registerComponent(TallyEndTotals);
engine.registerComponent(TimeManager);
engine.registerComponent(TouchController);
engine.registerComponent(TransitionController);
engine.registerComponent(TutorialGameRules);
engine.registerComponent(TutorialSpawner);
engine.registerComponent(TutorialTextScript);
engine.registerComponent(UnlockManager);
engine.registerComponent(WarningLine);
engine.registerComponent(UiTexturesManager);
engine.registerComponent(CreditsList);
engine.registerComponent(MainUI);
engine.registerComponent(AchievementIcons);
engine.registerComponent(CurtainsComponent);
engine.registerComponent(UnlockIcons);
/* wle:auto-register:end */
}
